<template>
  <v-dialog v-model="showAddCouponDialog" max-width="1200" persistent>
    <v-card v-if="showAddCouponDialog">
      <v-card-title class="primary white--text">
        <h3 class="headline">
          {{ $t('texts.coupon') }}
        </h3>
        <v-spacer/>
        <v-btn
          text small fab
          @click="closeDialog()"
        >
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <p>{{ $t('texts.redeemCouponDescription') }}</p>
      </v-card-text>
      <v-card-text>
        <v-text-field
          v-model="couponCheck.code"
          :label="$t('texts.coupon')"
          :error="couponCheck.valid === false"
          solo
          append-icon="check_circle_outline"
          :append-outer-icon="couponCheck.valid === false ? 'error' : ''"
          :loading="checkCouponCodePending"
          clearable
          @blur="validateCouponCode()"
          @click:append="validateCouponCode"
          @click:clear="clearCouponCode"
          required
        />
      </v-card-text>
      <v-card-text v-if="Object.keys(coupon).length > 0">
        <v-container class="pa-0">
          <v-row>
            <v-col :cols="12" :sm="4">{{ $t('texts.label') }}</v-col>
            <v-col :cols="12" :sm="8">{{ coupon.name }}</v-col>
          </v-row>
          <v-row>
            <v-col :cols="12" :sm="4">{{ $t('texts.value') }}</v-col>
            <v-col :cols="12" :sm="8">
              <template v-if="coupon.amount_off !== 0">
                CHF {{ coupon.amount_off }}.-
              </template>
              <template v-else>
                {{ coupon.percent_off }}%
              </template>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="12" :sm="4">{{ $t('texts.duration') }}</v-col>
            <v-col :cols="12" :sm="8">
              {{ coupon.duration_in_months }}
              {{ $tc('texts.months.label', coupon.duration_in_months) }}
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="primary"
          @click="validateBeforeSubmit()"
          :disabled="storeSubscriptionCouponPending || couponCheck.valid === null || !couponCheck.valid"
          :loading="storeSubscriptionCouponPending"
        >
          {{ $t('texts.redeemCoupon') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapSubscriptionState, mapActions: mapSubscriptionActions } = createNamespacedHelpers('subscription');
const { mapActions: mapMessageActions } = createNamespacedHelpers('messages');

export default {
  $_veeValidate: {
    validator: 'new',
  },
  name: 'AddCouponDialog',
  data() {
    return {
      showAddCouponDialog: false,
      form: {
        subscription_id: null,
        stripe_plan_id: '',
        company_id: null,
        coupon_code: '',
        next_possible_cancellation_date: '',
      },
      couponCheck: {
        code: '',
        loading: false,
        valid: null,
      },
      coupon: {},
    };
  },
  mounted() {
    this.$eventBus.$on('show-add-coupon-dialog', (payload) => {
      this.reset();
      Object.assign(this.form, payload);
      this.showAddCouponDialog = true;
    });
  },
  computed: {
    ...mapSubscriptionState([
      'checkCouponCodePending',
      'storeSubscriptionCouponPending',
    ]),
  },
  methods: {
    ...mapSubscriptionActions([
      'checkCouponCode',
      'storeSubscriptionCoupon',
    ]),
    ...mapMessageActions([
      'showMessageValidateError',
    ]),
    reset() {
      this.form = {
        subscription_id: null,
        company_id: null,
        coupon_code: '',
      };
      this.$validator.reset();
    },
    validateCouponCode() {
      if (this.couponCheck.code !== '' && this.couponCheck.code !== null) {
        this.couponCheck.valid = null;
        this.checkCouponCode({
          coupon_code: this.couponCheck.code,
        }).then((response) => {
          this.coupon = response.data.data;
          this.form.coupon_code = this.couponCheck.code;
          this.couponCheck.valid = true;
          this.couponCheck.code = '';
        }).catch(() => {
          this.couponCheck.valid = false;
        });
      }
    },
    clearCouponCode() {
      this.couponCheck = {
        code: '',
        loading: false,
        valid: null,
      };
    },
    closeDialog() {
      this.showAddCouponDialog = false;
      this.reset();
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.storeSubscriptionCoupon(this.form)
            .then(() => {
              this.showAddCouponDialog = false;
              this.reset();
            });
        } else {
          this.showMessageValidateError();
        }
      });
    },
  },
};
</script>
